export default function currency (input) {
    let number = (input/1).toFixed(2).replace('.', ',')
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
